//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { TABLE_SEARCH_BAR_WIDTH } from '@campaigns/constants/sampling/SamplingConstants';
import { BodySecondaryText } from '@components/atoms/text/Text';
import SearchBar from '@components/molecules/search-bar/SearchBar';

interface Props {
  resultsText: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const PurchaseOptionsTableControls = ({
  resultsText,
  searchTerm,
  setSearchTerm,
}: Props) => (
  <TableControlsContainer>
    <TableControlsSearchContainer>
      <TableSearchBar
        onChange={setSearchTerm}
        placeholder='Search by purchase option name'
        trackingIdPrefix={
          SAMPLING_CAMPAIGNS_TRACKING_ID.CAMPAIGN_REQUEST_PRODUCT_OPTIONS_SEARCH_BAR
        }
        value={searchTerm}
        visuallyHiddenLabel='Search by purchase option name'
      />
      <StyledBodySecondaryText wordBreak='normal'>
        {resultsText}
      </StyledBodySecondaryText>
    </TableControlsSearchContainer>
  </TableControlsContainer>
);

const TableControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TableControlsSearchContainer = styled.div(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacings[2]};
`,
);

const TableSearchBar = styled(SearchBar)`
  width: ${TABLE_SEARCH_BAR_WIDTH};
`;

const StyledBodySecondaryText = styled(BodySecondaryText)`
  white-space: nowrap;
`;
